export const filterFields =
    [
        'nr_pkbwl',
        'kategoria_statku_powietrznego',
        'typ_statku_powietrznego',
        'znaki_rozpoznawcze',
        'miejsce_zdarzenia',
        'data_zdarzenia',
        'klasyfikacja_zdarzenia',
        'godzina_zdarzenia',
        'status_badania',
        'operator_statku_powietrznego',
        'masa_mtow_statku_powietrznego',
        'poziom_obrazen',
        'podmiot_badajacy',
        'raport_wstepny',
        'uchwala',
        'raport_koncowy',
        'raport_koncowy_en',
        'oswiadczenie_tymczasowe',
        'osoba_badajaca_lub_nadzorujaca_zdarzenie',
        'przebieg_badania',
        'sklad_zespolu_badawczego',
        'kategoria_zdarzenia',
        'dodatkowe_uwagi',
        'accrep',
        'rodzaj_operacji',
        'kategoria_raportu',
        'nr_pkbwl',
        'numer_eccairs',
        'data_zdarzenia',
        'nr_pkbwl_od_do',
        'data_zakonczenia_badania',
        'zalecenia_bezpieczenstwa',
    ]